import { ClipboardEvent, KeyboardEvent } from 'react';
import { Input, InputProps } from './input';

export type InputNumberProps = Omit<InputProps, 'type'>;

const onlyDigitsAndDot = /^-?\d*(\.\d*)?$/;

export const InputNumber = (props: InputNumberProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const isModifierKey = event.metaKey || event.ctrlKey;
    const isActionKey = ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase()); // copy, paste, cut, select all

    if (
      !['Tab', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Enter'].some((key) => event.key === key) &&
      !onlyDigitsAndDot.test(`${props.value || ''}${event.key}`) && //  digits and dot
      !(isModifierKey && isActionKey)
    ) {
      event.preventDefault();
    }
  };

  const handlePasteNumberWithDecimals = (event: ClipboardEvent<HTMLInputElement>) => {
    if (!onlyDigitsAndDot.test(event.clipboardData?.getData('text'))) {
      event.preventDefault();
    }
  };

  return (
    <Input
      step="any" // Decimal issue https://stackoverflow.com/questions/48892570/please-enter-a-valid-value-the-two-nearest-valid-value-is
      onKeyDown={handleKeyDown}
      onWheel={(e) => e.currentTarget.blur()}
      onPasteCapture={handlePasteNumberWithDecimals}
      {...props}
      type="text" // number type is not working as expected in some cases when used with RHF
    />
  );
};
